import { getApiBase } from '../utils/apiBase';
import { globalCache } from './useDataCache';
const cache = new Map();
const CACHE_DURATION = 30000; // 30 seconds

export const prefetchData = async (url) => {
  const cachedData = cache.get(url);
  if (cachedData && Date.now() - cachedData.timestamp < CACHE_DURATION) {
    return cachedData.data;
  }

  try {
    const API = getApiBase();
    const fullUrl = /^https?:\/\//i.test(url)
      ? url
      : `${API}${url.startsWith('/') ? '' : '/'}${url}`;
    const response = await fetch(`${fullUrl}${fullUrl.includes('?') ? '&' : '?'}t=${Date.now()}`, { cache: 'no-store' });
    const data = await response.json();
    
    cache.set(url, {
      data,
      timestamp: Date.now()
    });
    try { globalCache.set(url, data); } catch {}
    
    return data;
  } catch (error) {
    console.error(`Error prefetching ${url}:`, error);
    return null;
  }
};